var _desc, _style, _g, _g2, _rect, _tspan, _tspan2, _tspan3, _rect2, _tspan4, _tspan5, _tspan6, _rect3, _tspan7, _tspan8, _rect4, _tspan9, _tspan0, _rect5, _tspan1, _tspan10, _tspan11, _defs, _defs2, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my-svg",
    width: 168,
    height: 521.7999877929688,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "flowchart",
    style: {
      maxWidth: 168,
      backgroundColor: "transparent"
    },
    viewBox: "4 4 168 521.7999877929688",
    role: "graphics-document document",
    "aria-roledescription": "flowchart-v2",
    "aria-describedby": "chart-desc-my-svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, "How PortCall fits together") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "chart-desc-my-svg"
  }, "Configure, control, plan, review, and record actuals.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#my-svg{font-family:Arial,sans-serif;font-size:16px;fill:#20303a;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#my-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#my-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#my-svg .error-icon{fill:#ffffff;}#my-svg .error-text{fill:#000000;stroke:#000000;}#my-svg .edge-thickness-normal{stroke-width:1px;}#my-svg .edge-thickness-thick{stroke-width:3.5px;}#my-svg .edge-pattern-solid{stroke-dasharray:0;}#my-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#my-svg .edge-pattern-dashed{stroke-dasharray:3;}#my-svg .edge-pattern-dotted{stroke-dasharray:2;}#my-svg .marker{fill:#667684;stroke:#667684;}#my-svg .marker.cross{stroke:#667684;}#my-svg svg{font-family:Arial,sans-serif;font-size:16px;}#my-svg p{margin:0;}#my-svg .label{font-family:Arial,sans-serif;color:#20303a;}#my-svg .cluster-label text{fill:#000000;}#my-svg .cluster-label span{color:#000000;}#my-svg .cluster-label span p{background-color:transparent;}#my-svg .label text,#my-svg span{fill:#20303a;color:#20303a;}#my-svg .node rect,#my-svg .node circle,#my-svg .node ellipse,#my-svg .node polygon,#my-svg .node path{fill:#edf5f8;stroke:#2e718e;stroke-width:1px;}#my-svg .rough-node .label text,#my-svg .node .label text,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-anchor:middle;}#my-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#my-svg .rough-node .label,#my-svg .node .label,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-align:center;}#my-svg .node.clickable{cursor:pointer;}#my-svg .root .anchor path{fill:#667684!important;stroke-width:0;stroke:#667684;}#my-svg .arrowheadPath{fill:#0b0b0b;}#my-svg .edgePaths .path{stroke:#667684;stroke-width:1px;}#my-svg .flowchart-link{stroke:#667684;fill:none;}#my-svg .edgeLabel{background-color:#f8fafb;text-align:center;}#my-svg .edgeLabel p{background-color:#f8fafb;}#my-svg .edgeLabel rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .labelBkg{background-color:rgba(248, 250, 251, 0.5);}#my-svg .cluster rect{fill:#ffffff;stroke:hsl(0, 0%, 90%);stroke-width:1px;}#my-svg .cluster text{fill:#000000;}#my-svg .cluster span{color:#000000;}#my-svg .node .collapsed-indicator{fill:hsl(0, 0%, 90%);stroke:none;opacity:0.6;}#my-svg .node .collapsed-separator{stroke:hsl(0, 0%, 90%);stroke-width:0.75px;}#my-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:Arial,sans-serif;font-size:12px;background:#ffffff;border:1px solid hsl(0, 0%, 90%);border-radius:2px;pointer-events:none;z-index:100;}#my-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#20303a;}#my-svg rect.text{fill:none;stroke-width:0;}#my-svg .icon-shape,#my-svg .image-shape{background-color:#f8fafb;text-align:center;}#my-svg .icon-shape p,#my-svg .image-shape p{background-color:#f8fafb;padding:2px;}#my-svg .icon-shape .label rect,#my-svg .image-shape .label rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .label-icon{display:inline-block;height:1em;overflow:visible;vertical-align:-0.125em;}#my-svg .node .label-icon path{fill:currentColor;stroke:revert;stroke-width:revert;}#my-svg .node .neo-node{stroke:#2e718e;}#my-svg [data-look=\"neo\"].node rect,#my-svg [data-look=\"neo\"].cluster rect,#my-svg [data-look=\"neo\"].node polygon{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].swimlane.cluster rect{filter:none;}#my-svg [data-look=\"neo\"].node path{stroke:url(#my-svg-gradient);stroke-width:1px;}#my-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node .neo-line path{stroke:#2e718e;filter:none;}#my-svg [data-look=\"neo\"].node circle{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#my-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg :root{--mermaid-font-family:Arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 4.5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 5 L 10 10 L 10 0 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 11.5,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 10.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 11.5 7 L 0 14 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 1,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,7 11.5,14 11.5,0",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 11,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -1,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refY: 5,
    refX: 12.25,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -2,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: 12,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: -1,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: 17.7,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: -3.5,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edges edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88,88.19999694824219L88,124.19999694824219",
    id: "my-svg-L_A_B_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_A_B_0",
    "data-points": "W3sieCI6ODgsInkiOjg4LjE5OTk5Njk0ODI0MjE5fSx7IngiOjg4LCJ5IjoxMjguMTk5OTk2OTQ4MjQyMn1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,204.39999389648438L88,240.39999389648438",
    id: "my-svg-L_B_C_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_B_C_0",
    "data-points": "W3sieCI6ODgsInkiOjIwNC4zOTk5OTM4OTY0ODQzOH0seyJ4Ijo4OCwieSI6MjQ0LjM5OTk5Mzg5NjQ4NDM4fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,302.99999237060547L88,338.99999237060547",
    id: "my-svg-L_C_D_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_C_D_0",
    "data-points": "W3sieCI6ODgsInkiOjMwMi45OTk5OTIzNzA2MDU0N30seyJ4Ijo4OCwieSI6MzQyLjk5OTk5MjM3MDYwNTQ3fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,401.59999084472656L88,437.59999084472656",
    id: "my-svg-L_D_E_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_D_E_0",
    "data-points": "W3sieCI6ODgsInkiOjQwMS41OTk5OTA4NDQ3MjY1Nn0seyJ4Ijo4OCwieSI6NDQxLjU5OTk5MDg0NDcyNjU2fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  })), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-A-0",
    "data-look": "neo",
    transform: "translate(88, 50.099998474121094)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Configure"))), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "verified"))), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "reference"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " data"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-B-1",
    "data-look": "neo",
    transform: "translate(88, 166.29999542236328)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Review"))), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "applicable"))), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "controls"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-C-3",
    "data-look": "neo",
    transform: "translate(88, 273.6999931335449)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Draft,"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " assign"))), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "and"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " position"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-D-5",
    "data-look": "neo",
    transform: "translate(88, 372.299991607666)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Review"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " and"))), _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "approve"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-E-7",
    "data-look": "neo",
    transform: "translate(88, 479.69998931884766)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Record"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " actuals"))), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "and"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " produce"))), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "outputs")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow",
    height: "130%",
    width: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 4,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow-small",
    height: "150%",
    width: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "my-svg-gradient",
    gradientUnits: "objectBoundingBox",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2e718e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "hsl(200, 0%, 87.8431372549%)",
    stopOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.53613a827475c1cf09006e4061ecb0ce.svg";
export { ForwardRef as ReactComponent };